module.exports = __webpack_public_path__ + "static/media/8.4be893b0.svg";